// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"0":"9fd54492","197":"d640b6be","501":"d640b6be","623":"d640b6be"}[chunkId] + ".chunk.css";
};